import React from 'react'
import styled from 'styled-components'

import { isNotNull } from '../../../../../utils/collectionTools'
import { OrderInvoiceEntry } from './OrderInvoiceEntry'
import { OrderInvoicesData } from './types'

const StyledInvoicesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.coolGray.cool250};
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  gap: 16px;
  ${OrderInvoiceEntry} {
    padding: 20px;
  }
  padding-bottom: 20px;
`

export interface InvoiceContentsProps {
  invoices: OrderInvoicesData
}

const InvoiceContents: React.FC<InvoiceContentsProps> = ({ invoices }) => {
  return (
    <>
      <h3 className="small-h3">Order Invoices</h3>
      <StyledInvoicesContainer>
        {invoices.filter(isNotNull).map((invoice) => (
          <OrderInvoiceEntry key={invoice.id} invoice={invoice} />
        ))}
      </StyledInvoicesContainer>
    </>
  )
}

const StyledInvoiceContents = styled(InvoiceContents)({
  marginBottom: '30px',
  paddingTop: '10px',
})

export default StyledInvoiceContents
